import { render, staticRenderFns } from "./FundsBlock.vue?vue&type=template&id=759b60d2&scoped=true"
import script from "./FundsBlock.vue?vue&type=script&lang=js"
export * from "./FundsBlock.vue?vue&type=script&lang=js"
import style0 from "./FundsBlock.vue?vue&type=style&index=0&id=759b60d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759b60d2",
  null
  
)

export default component.exports